export const SideBar = ({ children }: { children: React.ReactNode }) => (
  <div className="fixed left-10 sm:left-20 mt-14 bg-sidebar-menu border-r border-r-sidebar-menu-border h-screen z-10 w-[calc(100vw-5rem)] sm:w-md max-w-lg overflow-y-auto">
    {children}
  </div>
);
